(() => {
  'use strict';
  const key = 'spiritual-hoochie-saved-reading-v1';
  let abort;
  let memory = [];
  const safeUrl = value => {
    try { const origin = new URL(document.baseURI).origin; const url = new URL(value, origin); return url.origin === origin && url.pathname.startsWith('/') ? url.pathname + url.search + url.hash : null; } catch { return null; }
  };
  function loadReading() {
    try { const value = JSON.parse(localStorage.getItem(key) || '[]'); return Array.isArray(value) ? value.filter(item => item && typeof item.title === 'string' && typeof item.url === 'string' && safeUrl(item.url)).map(item => ({ title: item.title.slice(0, 300), url: safeUrl(item.url) })).slice(-40) : []; } catch { return memory; }
  }
  function boot() {
    abort?.abort(); abort = new AbortController();
    const on = (node, type, callback) => node?.addEventListener(type, callback, {signal: abort.signal});
    let saved = loadReading();
    const list = document.getElementById('sh-saved-reading');
    const controls = [...document.querySelectorAll('[data-sh-save-reading]')];
    const save = () => { memory = saved; try { localStorage.setItem(key, JSON.stringify(saved)); return true; } catch { return false; } };
    function render() {
      controls.forEach(button => {
        const active = saved.some(item => item.url === safeUrl(button.dataset.readingUrl));
        button.hidden = false; button.setAttribute('aria-pressed', String(active));
        button.querySelector('[data-sh-bookmark-label]').textContent = active ? button.dataset.savedLabel : button.dataset.saveLabel;
      });
      if (!list) return;
      list.replaceChildren();
      if (!saved.length) { const p = document.createElement('p'); p.textContent = list.dataset.empty; list.append(p); }
      saved.forEach(item => {
        const article = document.createElement('article'); article.className = 'sh-saved-item';
        const heading = document.createElement('h3'); heading.textContent = item.title;
        const link = document.createElement('a'); link.className = 'sh-text-button'; link.href = item.url; link.textContent = list.dataset.open;
        const remove = document.createElement('button'); remove.type = 'button'; remove.className = 'sh-text-button'; remove.textContent = list.dataset.remove;
        on(remove, 'click', () => { saved = saved.filter(entry => entry.url !== item.url); save(); render(); });
        article.append(heading, link, remove); list.append(article);
      });
    }
    controls.forEach(button => on(button, 'click', () => {
      const url = safeUrl(button.dataset.readingUrl); if (!url) return;
      const active = saved.some(item => item.url === url);
      saved = active ? saved.filter(item => item.url !== url) : [...saved, { title: button.dataset.readingTitle.slice(0,300), url }].slice(-40);
      const ok = save(); render();
      if (!ok && button.nextElementSibling) button.nextElementSibling.textContent = document.getElementById('sh-hub-ui')?.dataset.storageError || '';
    }));
    on(window, 'storage', event => { if (event.key === key) { saved = loadReading(); render(); } });
    const ritualKey = 'spiritual-hoochie-saved-rituals-v1';
    const ritualList = document.getElementById('sh-saved-list');
    const clearRituals = document.getElementById('sh-clear-saved');
    let rituals = [];
    const loadRituals = () => {
      try { const value = JSON.parse(localStorage.getItem(ritualKey) || '[]'); rituals = Array.isArray(value) ? value.filter(item => item && typeof item.id === 'string' && typeof item.name === 'string' && typeof item.prompt === 'string' && Array.isArray(item.steps) && item.steps.every(step => typeof step === 'string')).slice(-12) : []; } catch {}
    };
    const persistRituals = () => {
      try { localStorage.setItem(ritualKey, JSON.stringify(rituals)); }
      catch { const status = document.getElementById('sh-ritual-storage-status'); if (status) status.textContent = ritualList?.dataset.storageError || ''; }
    };
    function renderRituals() {
      if (!ritualList) return;
      ritualList.replaceChildren();
      if (!rituals.length) { const empty = document.createElement('p'); empty.textContent = ritualList.dataset.empty; ritualList.append(empty); }
      rituals.forEach(item => {
        const card = document.createElement('article'); card.className = 'sh-saved-item';
        const heading = document.createElement('h3'); heading.textContent = item.name;
        const steps = document.createElement('ol'); item.steps.forEach(text => { const step = document.createElement('li'); step.textContent = text; steps.append(step); });
        const prompt = document.createElement('p'); prompt.textContent = item.prompt;
        const remove = document.createElement('button'); remove.type = 'button'; remove.className = 'sh-text-button'; remove.textContent = ritualList.dataset.remove;
        on(remove, 'click', () => { rituals = rituals.filter(value => value.id !== item.id); persistRituals(); renderRituals(); });
        card.append(heading, steps, prompt, remove); ritualList.append(card);
      });
      if (clearRituals) clearRituals.hidden = rituals.length === 0;
    }
    loadRituals(); renderRituals();
    on(clearRituals, 'click', () => { rituals = []; persistRituals(); renderRituals(); });
    on(window, 'storage', event => { if (event.key === ritualKey) { loadRituals(); renderRituals(); } });
    render();
    document.querySelectorAll('[data-sh-directory]').forEach(directory => {
      const buttons = [...directory.querySelectorAll('[data-sh-category]')];
      const listings = [...directory.querySelectorAll('[data-sh-listing]')];
      const search = directory.querySelector('#sh-directory-location');
      let category = 'all';
      const filter = () => {
        const location = (search?.value || '').trim().toLocaleLowerCase();
        let count = 0;
        listings.forEach(card => { const visible = (category === 'all' || category === card.dataset.category) && card.dataset.location.includes(location); card.hidden = !visible; if (visible) count++; });
        const status = directory.querySelector('[data-sh-directory-count]');
        if (status) status.textContent = `${count} ${status.dataset.label}`;
        const empty = directory.querySelector('[data-sh-no-results]'); if (empty) empty.hidden = count !== 0;
      };
      buttons.forEach(button => on(button, 'click', () => { category = button.dataset.shCategory; buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button))); filter(); }));
      on(search, 'input', filter); filter();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once:true }); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
